<template>
  <div class="spot-freight-ctnr">
    <navbar :showShadow="false" :scrollChange="false" :tabId="5"></navbar>
    <div class="spot-freight-wrp">
      <SearchPanel
        ref="searchPanelRef"
        @search="onSearch"
        :layout="layout"
      ></SearchPanel>
      <div class="default-area" v-if="layout.showDefault">
        <DefaultPanel></DefaultPanel>
      </div>
      <template v-else>
        <div class="filter-panel">
          <FilterPanel
            :layout="layout"
            :filterShippingList="filterShippingList"
            @filter="onFilter"
            ref="filterPanelRef"
          ></FilterPanel>
        </div>
        <div class="main-table">
          <MainTable
            :chooseForm="chooseForm"
            :sticky="sticky"
            :list="list"
            :layout="layout"
            @detail-tap="onDetailTap"
          ></MainTable>
        </div>
      </template>
    </div>
    <DetailDialog
      v-if="showDetail"
      :chooseData="chooseData"
      :chooseContainerType="chooseForm.containerType"
      @close="showDetail = false"
    ></DetailDialog>
  </div>
</template>

<script>
import { MessageError } from "@/utils/GlobalError";
import { Sticky } from "@/utils/scroll";
import SearchPanel from "./component/SearchPanel/index.vue";
import FilterPanel from "./component/FilterPanel/index.vue";
import MainTable from "./component/MainTable/index.vue";
import DefaultPanel from "./component/DefaultPanel/index.vue";
import {
  generateBatchNoAPI,
  getListByBatchNoAPI,
  getStatusAPI,
} from "@/api/spotFreight/index.js";
import { DateTime } from "@/utils/DateTime";
import DetailDialog from "./component/dialogs/Edit/index.vue";
import { isCheckUserStatusAPI } from "@/api/common.js";
import { mapState } from "vuex";
export default {
  components: {
    SearchPanel,
    FilterPanel,
    MainTable,
    DefaultPanel,
    DetailDialog,
  },
  data() {
    return {
      sticky: {},
      showDetail: false,
      layout: {
        showDefault: true,
        showTableEmpty: false,
        showTableBody: false,
        showLoading: false,
      },
      list: [], // 经过排序筛选等展示的数据
      originList: [], // 查询到的原始数据
      loopConfig: {
        loopLimit: 8,
        loopInterval: 5000,
      },
      loopStatus: {
        looping: null, // 判断循环中的标记，当否定时，循环会退出中止
        loopNum: 0, // 当前循环次数
      },
      chooseData: {},
      chooseForm: {},
      filterShippingList: [],
      isVip: false,
    };
  },
  computed: {
    ...mapState("user", {
      userId: (state) => state.userId,
    }),
  },
  destroyed() {
    this.clearLoop();
    console.log("==========clear loop on unload");
  },
  created() {},
  mounted() {
    // this.onSearch();
    
    if (!this.$isInputEmpty(this.userId)) {
      this.getUserStatus();
    }
  },
  methods: {
    async getUserStatus() {
      let res = await isCheckUserStatusAPI({});
      console.log("isCheckUserStatusAPI============",res);
      let id = res.id || "";
      this.isVip = this.$isInputEmpty(id) ? false : true;
      // this.isVip = true;
    },
    initScroll() {
      if (this.sticky && this.sticky.destroy) {
        this.sticky.destroy();
      }
      this.sticky = new Sticky({
        selector: "#fixedThead",
        offset: 0,
        vm: this,
      }).tableHeadSticky();
      console.log("==========this.sticky", this.sticky);
      if (document.documentElement.scrollTop >= this.sticky.finalTop) {
        this.sticky.isFixed = true;
      } else {
        this.sticky.isFixed = false;
      }
    },

    clearAndLoading() {
      this.list = [];
      this.originList = [];
      this.layout = {
        showDefault: false,
        showTableEmpty: false,
        showTableBody: true,
        showLoading: true,
      };
      this.resetFilter();
      this.clearLoop();
    },
    resetFilter() {
      let comp = this.$refs.filterPanelRef;
      if (comp) {
        comp.reset();
      }
    },

    async onSearch() {
      this.clearAndLoading();
      try {
        // generate a batch no to loop search
        let batchNo = await this.getBatchNo();
        console.log("==========getBatchNo", batchNo);
        // start loop search
        this.loopStatus.looping = true;
        this.initScroll()
        await this.recursiveLoop(batchNo);
        if (this.list.length <= 0) {
          this.originList = [];
          this.layout = {
            showDefault: false,
            showTableEmpty: true,
            showTableBody: false,
            showLoading: false,
          };
        } else {
          this.originList = [...this.list];
          this.layout = {
            showDefault: false,
            showTableEmpty: false,
            showTableBody: true,
            showLoading: false,
          };
        }
      } catch (e) {
        this.clearLoop();
        if (this.list.length <= 0) {
          this.originList = [];
          this.layout = {
            showDefault: false,
            showTableEmpty: true,
            showTableBody: false,
            showLoading: false,
          };
        } else {
          this.originList = [...this.list];
          this.layout = {
            showDefault: false,
            showTableEmpty: false,
            showTableBody: true,
            showLoading: false,
          };
        }
        if (e instanceof MessageError) {
          this.$message({
            message: e.message,
            type: "error",
          });
          console.error("后台消息错误", e);
        } else {
          console.error("返回码错误", e);
        }
      } finally {
      }
    },
    async getBatchNo() {
      let form = this.getSearchPanelForm();
      let params = {
        portStartId: form.portStartId,
        portEndId: form.portEndId,
        shippingIds: form.shippingIds,
        boxTypes: form.containerType,
        toTransportType: form.toTransportType,
        fromTransportType: form.fromTransportType,
        vipFlag : this.isVip,
      };
      // 备份一套
      this.chooseForm = { ...form };
      let res = await generateBatchNoAPI(params);
      console.log("========== generateBatchNoAPI res", res);
      res = res;
      if (+res.code !== 1) {
        throw new MessageError(res.message, res.code);
      }
      return res.data;
    },
    // 递归循环
    async recursiveLoop(batchNo) {
      // 递归前置判断
      if (!(await this.beforeCheck(batchNo))) {
      await this.getList(batchNo);
        // 未通过递归前置校验 中断递归
        this.clearLoop();
        return;
      }
      // 递归执行
      await this.getList(batchNo);
      this.loopStatus.loopNum += 1;
      await this.waitTime();
      // 递归自身
      await this.recursiveLoop(batchNo);
    },
    // 递归前置判定
    async beforeCheck(batchNo) {
      // status check
      if (this.loopStatus.looping === null) {
        console.log("==========主动停止循环");
        return false;
      }
      // limit check
      if (this.loopStatus.loopNum > this.loopConfig.loopLimit) {
        return false;
      }

      let status = await this.getStatus(batchNo);
      if (status) {
        return false;
      }
      return true;
    },
    waitTime() {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve();
        }, this.loopConfig.loopInterval);
      });
    },
    clearLoop() {
      this.loopStatus = {
        loopNum: 0,
        looping: null,
      };
    },
    async getStatus(batchNo) {
      let res = await getStatusAPI({ batchNumber: batchNo });
      res = res;
      console.log("==========status返回的res.data", res);
      if (+res.code !== 1) {
        throw new MessageError(res.msg);
      }
      if (res.data) {
        //  加载完成
        return true;
      } else return false;
    },
    async getList(batchNo) {
      console.log("==========call list api");
      let res = await getListByBatchNoAPI({ batchNumber: batchNo });
      console.log("==========get list api", res.data);
      res = res;
      let list = res || [];
      list = this.handleList(list);
      this.list = [...list];
    },
    handleList(list = []) {
      const handlePrice = (price) => {
        if (this.$emp(price)) {
          return price;
        } else {
          let numPrice = Number(price);
          if (isNaN(numPrice)) {
            return numPrice;
          } else {
            return numPrice;
          }
        }
      };
      return list.map((item, index) => {
        let newItem = { ...item };
        newItem.convert = {};
        newItem.convert.containerType = this.chooseForm.containerType;
        let hasPosition = item[`havePosition${newItem.convert.containerType}`];
        newItem.convert.hasPosition = hasPosition;
        let price = item[`price${newItem.convert.containerType}`];
        newItem.convert.price = handlePrice(price);

        return {
          ...newItem,
          id: list.length - index,
        };
      });
    },

    getSearchPanelForm() {
      let params = this.$refs.searchPanelRef.getParams();
      this.filterShippingList = JSON.parse( JSON.stringify(params.shippingOptions) ) || [];
      return { ...params };
    },
    async onFilter(e) {
      let comp = this.$refs.filterPanelRef;
      let fp = {};
      if (comp) {
        fp = comp.GetParams();
      }
      // 取原始数组
      let list = [...this.originList];
      if (fp.spaceActive) {
        list = list.filter((item) => item.convert.hasPosition === "1");
      }
      if (fp.dirActive) {
        list = list.filter((item) => {
          return item.travelWay == "直航";
        });
      }
      // filter
      if (fp.shippings && fp.shippings.length > 0) {
        list = list.filter((item) => {
          return fp.shippings.includes(item.shipCompany);
        });
      }
      if (fp.etdRange && fp.etdRange.length > 0) {
        list = list.filter((item) => {
          if (!item.departureTime) return false;
          let stamp = DateTime.getStamp(item.departureTime);
          if (stamp >= fp.etdRange[0] && stamp <= fp.etdRange[1]) {
            return true;
          }
        });
      }
      // sort etd
      if (fp.order === 1) {
        list = list.sort((a, b) => {
          if (a.departureTime === null && b.departureTime) return 1;
          if (a.departureTime && b.departureTime === null) return -1;
          if (a.departureTime === null && b.departureTime === null) return 0;
          let time_a = DateTime.getStamp(a.departureTime);
          let time_b = DateTime.getStamp(b.departureTime);
          return time_a - time_b;
        });
      }
      //   // sort voyage
      else if (fp.order === 2) {
        list = list.sort((a, b) => {
          if (this.$emp(a.tripTime) && this.$emp(b.tripTime)) return 0;
          if (!this.$emp(a.tripTime) && this.$emp(b.tripTime)) return -1;
          if (this.$emp(a.tripTime) && !this.$emp(b.tripTime)) return 1;
          return a.tripTime - b.tripTime;
        });
      }
      //   // sort price
      else if (fp.order === 3) {
        list = list.sort((a, b) => {
          if (this.$emp(a.convert.price) && this.$emp(b.convert.price))
            return 0;
          if (!this.$emp(a.convert.price) && this.$emp(b.convert.price))
            return -1;
          if (this.$emp(a.convert.price) && !this.$emp(b.convert.price))
            return 1;
          return Number(a.convert.price) - Number(b.convert.price);
        });
      } else {
        // 默认排序
      }

      this.list = [...list];
      if (this.list.length <= 0) {
        this.layout = {
          showDefault: false,
          showTableEmpty: true,
          showTableBody: false,
          showLoading: false,
        };
      } else {
        this.layout = {
          showDefault: false,
          showTableEmpty: false,
          showTableBody: true,
          showLoading: false,
        };
      }
    },
    onDetailTap(e) {
      this.chooseData = e;
      this.showDetail = true;
      // let chooseForm = this.$refs.searchPanelRef.getParams();
      // this.chooseForm = chooseForm || {};
    },
  },
};
</script>

<style scoped lang="scss">
.spot-freight-ctnr {
  background-color: #f6f9fc;
  padding-top: 98px;
  min-height: 100vh;
  box-sizing: border-box;
  padding-bottom: 104px;
  * {
    box-sizing: border-box;
  }
  .spot-freight-wrp {
  }
}
</style>
<style>
.spot-freight-ctnr {
  * {
    box-sizing: border-box;
  }
}
</style>
